<template>
  <div>
    <v-row class="mb-1">
      <v-col cols="12">
        <h3 class="font-weight-bold">
          {{ translation(translationList.address_type, 'Locatie') }}
        </h3>
        <p class="font-weight-regular">
          {{
            translation(translationList.period_of_time, 'Alege zona în care se află locuința ta')
          }}
        </p>
      </v-col>
    </v-row>
    <div
        class="border-0 px-0 py-0 d-inline-flex w-100"
        v-if="addressTypeList && addressTypeList.length"
    >
      <div
          v-for="(addressType, index) in addressTypeList"
          :key="index"
          class="w-100"
      >
        <div
            class="px-5 py-2 cursor-pointer w-100 text-center border rounded-lg"
            @click="onTabChange(addressType)"
            :class="addressType.id === selectedAddressType.id ? 'bg-secondary' : 'bg-secondary-accent'"
        >
          {{ addressType.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted} from 'vue';
import {translation, useTranslationStore} from "~/plugins/store/translations";
import {type AddressType} from '~/types/House';
import {useHouseStore} from "~/plugins/store/house";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => AddressType,
      default: false,
    },
  },
  setup(props, {emit}) {
    const selectedAddressType = ref<AddressType>(props.modelValue);
    const translationList = ref<TranslationList>({});
    const addressTypeList = ref<AddressType[]>([]);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();

    const onTabChange = (newValue: AddressType) => {
      selectedAddressType.value = newValue;
      emit('update:modelValue', newValue);
    };

    watch(() => props.modelValue, (newValue) => {
      selectedAddressType.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      addressTypeList.value = await houseStore.getAddressTypeList();
    });

    return {
      selectedAddressType,
      onTabChange,
      translationList,
      translation,
      addressTypeList
    };
  },
});
</script>

<style scoped>

</style>
